// src/components/ShiftRosterTable.jsx

import React from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
const useStyles = makeStyles((theme) => ({
  root: {
    "& .MuiFormLabel-root": {
      color: "red", // or black
    },
  },
  head: {
    backgroundColor: "#F9FAFB",
    color: "#0A0B0A",
    fontSize: "14px",
    fontWeight: 600,
    lineHeight: "18px",
    whiteSpace: "nowrap",
    borderBottom: "1px solid #E4E7EC",
  },
  cellWithRightBorder: {
    borderRight: "1px solid #E4E7EC", // Add right border to specific cells
  },
}));
const ShiftRosterTable = ({ data, columns }) => {
  const classes = useStyles();

  const getColSpanCounts = () => {
    const employeeColumns = columns.filter(
      (col) => col.category === "employee"
    );
    const shiftColumns = columns.filter((col) => col.category === "shift");

    return {
      employeeColSpan: employeeColumns.length,
      shiftColSpan: shiftColumns.length,
    };
  };

  const { employeeColSpan, shiftColSpan } = getColSpanCounts();
  return (
    <TableContainer
      component={Paper}
      sx={{
        backgroundColor: "#F9FAFB",
      }}
    >
      <Table
        sx={{
          borderBottom: "1px solid orange",
        }}
      >
        <TableHead>
          <TableRow>
            <TableCell
              align="center"
              colSpan={2}
              classes={{ root: classes.root, head: classes.head }}
              className={employeeColSpan > 1 ? classes.cellWithRightBorder : ""}
              sx={{
                backgroundColor: "#F3F4F6",
                fontWeight: 700,
                color: "#111827",
                fontSize: "14px",
              }}
            >
              Employee details
            </TableCell>
            <TableCell
              align="center"
              colSpan={shiftColSpan}
              classes={{ root: classes.root, head: classes.head }}
              sx={{
                backgroundColor: "#F3F4F6",
                fontWeight: 700,
                color: "#111827",
                fontSize: "14px",
              }}
            >
              Shift details
            </TableCell>
          </TableRow>
          <TableRow>
            {columns.map((column) => (
              <TableCell
                classes={{ root: classes.root, head: classes.head }}
                key={column.key}
                align={column.align || "left"}
                // className={
                //   employeeColSpan > 1 ? classes.cellWithRightBorder : ""
                // }
              >
                {column.title}
              </TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {data.map((row, index) => (
            <TableRow key={index}>
              {columns.map((column) => (
                <TableCell
                  key={column.key}
                  align={column.align || "left"}
                  sx={{
                    borderColor: "#E4E7EC",
                    backgroundColor: "#FFFFFF",
                  }}
                >
                  {row[column.dataIndex]}
                </TableCell>
              ))}
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default ShiftRosterTable;
